import { Link } from '@/components/link/Link';
import { UrlObject } from 'url';

type Url = string | UrlObject;
export default function CercleLinKButton({
  href,
  text,
  fillWidth,
  inverceTheme,
}: {
  href: Url;
  text: string;
  fillWidth?: boolean;
  inverceTheme?: boolean;
}) {
  const bgColor = inverceTheme ? 'bg-phone-primary' : 'bg-white';
  const textColor = inverceTheme ? 'text-white' : 'text-phone-primary';
  return (
    <div className="mx-4">
      <div className="flex justify-center">
        <Link href={href} legacyBehavior>
          <button
            type="button"
            className={`text-sm border border-phone-primary font-bold py-3 px-10 rounded-full inline-flex items-center justify-center 
                 ${bgColor} ${textColor} ${fillWidth ? 'flex-1' : ''}`}
          >
            {text}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 256 256">
              <title>more</title>
              <path
                fill="currentColor"
                d="m184.49 136.49l-80 80a12 12 0 0 1-17-17L159 128L87.51 56.49a12 12 0 1 1 17-17l80 80a12 12 0 0 1-.02 17"
              />
            </svg>
          </button>
        </Link>
      </div>
    </div>
  );
}
